exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emptyState{position:absolute;width:100%;opacity:0.8;font-size:22px;text-align:center;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;padding-bottom:100px;margin-top:30px}.emptyState .title{font-size:22px;text-align:center;display:block}.emptyState .info{width:474px;height:53px;font-size:14px;margin:20px 0 30px}.emptyState .goBack{font-size:14px;line-height:1;letter-spacing:normal;text-align:center;padding-top:10px;margin:0 auto;padding:10px 5px;width:134px;cursor:pointer}.emptyState .message{font-size:22px;line-height:1.5}.mobile .emptyState{position:static !important}.mobile .emptyState .message{font-size:24px}.mobile .emptyState .info{width:100% !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/widget/components/emptyState/EmptyState.scss
// module id = 487
// module chunks = 0 1